"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveChatPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var page_path_1 = require("./components/page_path");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var logo_png_1 = __importDefault(require("../../assets/logo.png"));
var get_chats_1 = require("../../api/calls/chats/get_chats");
var LiveChatPage = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)([]), userChats = _a[0], setUserChats = _a[1];
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    (0, react_1.useEffect)(function () {
        //Get Provider
        setIsLoading(true);
        if (user === null || user === void 0 ? void 0 : user.uid) {
            (0, get_chats_1.getChats)().then(function (response) {
                var _a;
                if (response.success) {
                    var tempData_1 = [];
                    (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.forEach(function (doc) {
                        var chatData = doc.data();
                        tempData_1.push(__assign({ uid: doc.id }, chatData));
                    });
                    setUserChats(tempData_1);
                    setIsLoading(false);
                }
                else {
                }
            });
        }
    }, [user]);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-4" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "/",
                        title: "Home",
                    },
                    {
                        page: "",
                        title: "Live Chat",
                        active: true,
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex flex-row justify-between items-center " },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, size: "4xlarge", label: "Chat", textColor: "text-primary" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-4" },
                react_1.default.createElement("div", { className: " flex flex-col  gap-4  lg:w-5/12 shadow hover:shadow-lg transition-shadow p-4 rounded-md" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Search Users", startIcon: pro_solid_svg_icons_1.faSearch, size: "small" }),
                    react_1.default.createElement("div", { className: "flex flex-row cursor-pointer rounded-md bg-slate-50 px-2 py-1 gap-2" },
                        react_1.default.createElement("img", { src: logo_png_1.default, className: "rounded-full h-8 w-8" }),
                        react_1.default.createElement("div", { className: "flex flex-col" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Desmond Makhubela", size: "small" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "desmond@doshex.com", size: "xsmall" }))),
                    react_1.default.createElement("div", { className: "flex flex-row cursor-pointer rounded-md bg-slate-50 px-2 py-1 gap-2" },
                        react_1.default.createElement("img", { src: logo_png_1.default, className: "rounded-full h-8 w-8" }),
                        react_1.default.createElement("div", { className: "flex flex-col" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Desmond Makhubela", size: "small" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "desmond@doshex.com", size: "xsmall" })))),
                react_1.default.createElement("div", { className: "flex flex-col gap-4 lg:w-7/12 shadow hover:shadow-lg transition-shadow p-4 rounded-md" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "flex flex-row gap-2" },
                            react_1.default.createElement("img", { src: logo_png_1.default, className: "rounded-full h-8 w-8" }),
                            react_1.default.createElement("div", { className: "flex flex-row items-center gap-2" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Desmond Makhubela", size: "small" }),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "\u2022", size: "small" }),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "desmond@doshex.com", size: "xsmall" }))),
                        react_1.default.createElement(doshx_controls_web_1.DividerControl, { orientation: "horizontal", lineColor: "bg-slate-200" }),
                        react_1.default.createElement("div", { className: "flex flex-col gap-4 " },
                            react_1.default.createElement("div", { className: "flex flex-row cursor-pointer  px-2 py-1 gap-2 justify-start items-center" },
                                react_1.default.createElement("img", { src: logo_png_1.default, className: "rounded-full h-8 w-8" }),
                                react_1.default.createElement("div", { className: "flex flex-col gap-1" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "12:33 AM", size: "xsmall", textColor: "text-black" }),
                                    react_1.default.createElement("div", { className: "flex flex-col rounded-lg rounded-bl-none bg-primary bg-opacity-10 p-2 max-w-xs" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, labore et dolore magna aliqua.", size: "xsmall", textColor: "text-black" })))),
                            react_1.default.createElement("div", { className: "flex flex-row cursor-pointer  px-2 py-1 gap-2  justify-end items-center" },
                                react_1.default.createElement("div", { className: "flex flex-col gap-1 items-end" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "12:33 AM", size: "xsmall", textColor: "text-black" }),
                                    react_1.default.createElement("div", { className: "flex flex-col rounded-lg rounded-br-none bg-primary bg-opacity-80 p-2 max-w-xs" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.", size: "xsmall", textColor: "text-white" }))),
                                react_1.default.createElement("img", { src: logo_png_1.default, className: "rounded-full h-8 w-8" })))))))));
};
exports.LiveChatPage = LiveChatPage;
